import Vue from 'vue'
import Vuex from 'vuex'

import user from './user'
import global from './global'
import indication from './indication'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    global,
    indication
  },
  getters: {
    access: state => state.user.access,
    refresh: state => state.user.refresh,
    id: state => state.user.id,
    member_code: state => state.user.member_code,
    nickname: state => state.user.nickname,
    avatar: state => state.user.avatar,
    wh_id: state => state.user.wh_id,
    jiyun_page_banner: state => state.user.jiyun_page_banner,
    indication: state => state.indication,
    hasLogin: state => state.user.hasLogin,
    oversea_warehouse_enable: state => !!state.global.oversea_warehouse_enable,
    hk_area: state => {
      const leaf = (list) => {
        if (!list) return []
        list.forEach(e => {
          if (!e.children || !e.children.length) {
            e.leaf = true
            delete e.children
          } else {
            leaf(e.children)
          }
        })
        return list
      }
      return leaf(state.global.hk_area || [])
    },
    jiyun_type_list: state => state.global.jiyun_type_list,
    country_list: state => state.global.country_list,
    declare_category: state => state.global.declare_category,
    declare_category_for_code_map: (state) => {
      if (!state.global.declare_category) return {}
      return state.global.declare_category.reduce((map, ele) => {
        if (!ele.sub) {
          map[ele.code] = ele.name_zhcn
        } else {
          ele.sub.forEach((e) => {
            map[[ele.code, e.code].join('-')] = {
              category_text: ele.name_zhcn,
              category_sub_text: e.name_zhcn,
            }
          })
        }
        return map
      }, {})
    },
    express_map: state => {
      if (!state.global.express_list) return {}
      return state.global.express_list.reduce((map, { id, name }) => (map[id] = name, map), {})
    },
    express_list: state => {
      const list = state.global.warehouse_list || []
      return list.reduce((map, { express_list }) => map.concat(express_list || []), [])
    },
    warehouse_list: state => {
      if (!state.global.warehouse_list) return []
      return state.global.warehouse_list.map(e => {
        return {
          ...e,
          express_list: ((e.express_list || []).slice().sort((a, b) => a.id - b.id)).map((el, index) => ({
            ...el,
            name: index + 1 + '、' + el.name
          }))
        }
      })
    }
  }
})